import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("demo@saviarsoftlife.com");
  const [password, setPassword] = useState("SaviarReset2025");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (user && typeof user === "object") return <Navigate to={user.role === "admin" ? "/admin/applications" : "/portal"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) nav(email.includes("info@saviar") || email.includes("admin") ? "/admin/applications" : "/portal");
    else setError(res.error);
  };

  return (
    <div className="form-section" data-testid="login-page">
      <div className="form-wrap">
        <Link to="/" className="brand-mark" style={{ display: "inline-block", marginBottom: 40 }}>SAVIAR</Link>
        <p className="eyebrow eyebrow-light">Client Portal</p>
        <h1 style={{ fontFamily: "var(--serif)", fontSize: "clamp(2rem, 4vw, 3rem)", fontWeight: 300, color: "var(--ivory)", margin: "16px 0 12px" }}>Welcome home.</h1>
        <p style={{ color: "rgba(250,246,238,.5)", marginBottom: 40, fontSize: ".92rem" }}>Sign in to access your Saviar residency companion.</p>

        <form onSubmit={submit} data-testid="login-form">
          <div className="form-group">
            <label>Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          {error && <p style={{ color: "#e08b8b", fontSize: ".85rem", marginBottom: 16 }} data-testid="login-error">{error}</p>}
          <button type="submit" className="btn btn-primary" disabled={busy} style={{ width: "100%" }} data-testid="login-submit">
            {busy ? "Signing in…" : "Enter Portal"}
          </button>
        </form>

        <div style={{ marginTop: 32, padding: 20, border: "1px solid rgba(184,150,90,.2)", background: "rgba(184,150,90,.04)" }}>
          <p className="eyebrow" style={{ marginBottom: 8 }}>Demo Access</p>
          <p style={{ color: "rgba(250,246,238,.65)", fontSize: ".82rem", lineHeight: 1.7 }}>
            Guest: demo@saviarsoftlife.com&nbsp;·&nbsp;SaviarReset2025<br/>
            Admin: info@saviar.online&nbsp;·&nbsp;SaviarAdmin2025<br/>
            <span style={{ color: "rgba(250,246,238,.4)" }}>Guest is pre-filled.</span>
          </p>
        </div>
        <p style={{ marginTop: 24, color: "rgba(250,246,238,.5)", fontSize: ".85rem", textAlign: "center" }}>
          New here? <Link to="/register" style={{ color: "var(--gold-light)" }} data-testid="link-register">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
